import React, { useState, useEffect } from 'react';
import { Button, DatePicker, Checkbox, Input, Popconfirm, Tooltip, Modal } from 'antd';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';
import './UserView.css';
import Labels from './Labels.json';
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { addFileDrugTest, addDrugTestDate, deleteDrugTestDate, saveDrugTestComment, deleteFileDrugTest, fetchDrugTestData } from '../../services/Service';
import { fetchEmployeeData,DeleteConfirmButton } from '../../util/documentConfig';
import { toast } from "react-toastify";
import { showErrorNotification, showNotification, showWarningNotification } from '../../util/documentConfig';

function DisplayDrugTest({ onFileUploadSuccess }) {

  // State variables
  const [drugTestDate, setDrugTestDate] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [comments, setComments] = useState('');
  const [commentError, setCommentError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileData, setFileData] = useState(null); // Stores Base64 Data
  const [fileName, setFileName] = useState('');
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false); // checks document has been uploaded
  const [isAdmin, setIsAdmin] = useState(false);
  const [userId, setUserId] = useState(null); // Store userId in state

  const { id } = useParams(); // Get userId from URL if available
  const email = localStorage.getItem("userEmail");
  const token = useSelector((state) => state.auth.token);
  // Checks from localStorage
  useEffect(() => {
    const roleUser = JSON.parse(localStorage.getItem("userRoles"));

    if (roleUser && roleUser.includes("ADMINUSER")) {
      // alert("setAdmin");
      setIsAdmin(true);
    }

    // If userId is not available, fetch it using email
    if (!id) {
      fetchData();
    } else {
      setUserId(id); // Set from URL params
    }
  }, [id]); // Depend on id so it updates properly when URL changes


  useEffect(() => {
    if (userId) {
      handleGetStatus(); // Fetch status only after userId is available
    }
  }, [onFileUploadSuccess, userId]); // Depend on userId to trigger status check


  const fetchData = async () => {
    try {
      const fetchedUserId = await fetchEmployeeData(email);
      console.log(`User ID: ${fetchedUserId}`);
      setUserId(fetchedUserId);
    } catch (error) {
      console.error("Failed to fetch userId:", error);
      showErrorNotification("Failed to fetch userId");
    }
  };

  const handleGetStatus = async () => {
    try {
      const userData = await fetchDrugTestData(userId);

      console.log("Raw Response:", userData);

      //const attemptedDate = userData?.data?.[0]?.attemptedDate;
      //console.log("Attempted Date:", attemptedDate);

      if (userData.data.attemptedDate != null) {
        setComments(userData.data.comments || '');
        setDrugTestDate(userData.data.attemptedDate || '');
        setIsChecked(!!userData.data.attemptedDate);

        const fileData = userData.data;

        console.log("File data from response:", fileData);

        // Update state
        setUploadedFile(fileData.fileName);
        setFileName(fileData.fileName);
        setFileData(fileData.fileBase64);
        setIsChecked(true);
        onFileUploadSuccess(true);

        // Save to localStorage
        /* localStorage.setItem(
           `drugFile_${userId}`,
           JSON.stringify({
             fileName: fileData.filename,    // ✅ Correct key for filename
             fileBase64: fileData.fileData,  // ✅ Correctly reference fileData as base64
             isChecked: true,
           })
         );*/

      }
      else {
        onFileUploadSuccess(false);
        //alert("Failed to retrieve BGV status");
      }
    } catch (error) {
      console.error('Error loading user data:', error);
    }
  };




  // Convert file to Base64 for storage
  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!userId) {
      console.error("User ID not found in the URL!");
      showWarningNotification("User ID is missing!");
      return;
    }

    let newFileName = file.name;

    // Check if userId is already in the filename
    if (!file.name.includes(userId)) {
      newFileName = `${userId}_${file.name}`;
    }

    // Create a new File object with the final name
    const renamedFile = new File([file], newFileName, { type: file.type });

    // ✅ Send file and JSON data separately
    const uid = `${userId}`;
    const formData = new FormData();
    formData.append('file', renamedFile);
    //const requestData = { file: renamedFile, status: "Completed" };

    try {


      const response = await addFileDrugTest(formData, uid);

      if (response.ok) {
        const result = response.data;

        console.log("Upload successful:", result);
        showNotification(`File uploaded successfully as ${newFileName}`);
        // Convert to Base64 and update state
        const base64 = await convertFileToBase64(renamedFile);
        const fileData = {
          fileName: newFileName,
          fileBase64: base64,
          isChecked: true,
        };
        setUploadedFile(newFileName);
        setFileName(newFileName);
        setFileData(base64);
        setIsChecked(true);
        onFileUploadSuccess(true);

        // Save to localStorage (unique for each user)
        //localStorage.setItem(`drugFile_${userId}`, JSON.stringify(fileData));
      } else {
        console.error("Upload failed:", response.data.error);
        showErrorNotification("File upload failed: " + response.data.error);

      }
    } catch (error) {
      console.error("Error uploading file:", error);
      showErrorNotification("An error occurred while uploading the file.");
    }
  };

  const downloadDocument = async () => {
    try {
      const response = await fetchDrugTestData(userId);
      console.log("Response:", response);

      if (response && response.data) {

        const fileData = response.data;;
        console.log("File data from response:", fileData);

        const fileName = fileData.fileName;
        const fileExtension = fileName.split('.').pop().toLowerCase();
        const fileType = fileData.fileType;

        let base64Data = fileData.fileData;
        //alert(base64Data);
        // 🛠️ Check if Base64 data is in a data URI format
        if (base64Data.startsWith('data:')) {
          base64Data = base64Data.split(',')[1]; // Extract the base64 part
        }

        try {
          // ✅ Decode Base64 data to binary
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          // ✅ Create a Blob with the correct type
          const blob = new Blob([byteNumbers], { type: fileType });
          const fileUrl = URL.createObjectURL(blob);

          // ✅ Handle PDF separately, others trigger download
          if (fileExtension === 'pdf') {
            window.open(fileUrl, '_blank');
          } else {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          // ✅ Clean up memory after download
          setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
        } catch (decodeError) {
          console.error('Error decoding Base64 data:', decodeError);
          showErrorNotification('Failed to decode file data. File may be corrupted.');
        }

      } else {
        showErrorNotification('Failed to retrieve file data.');
      }
    } catch (error) {
      console.error('Error downloading file:', error);
      showErrorNotification('An error occurred while downloading the file.');
    }
  };



  // Function to handle opening the uploaded document
  const handleOpenDocument = () => {
    if (!fileName || !fileData) {
      console.error("No file uploaded or file data is missing.");
      showWarningNotification("Please upload a valid file before opening.");
      return;
    }
    try {
      const fileExtension = fileName.split('.').pop().toLowerCase();
      const fileBlob = fetch(fileData).then(res => res.blob());
      fileBlob.then(blob => {
        const fileUrl = URL.createObjectURL(blob);
        if (fileExtension === 'pdf') {
          window.open(fileUrl, '_blank');
        } else {
          const link = document.createElement('a');
          link.href = fileUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
      });
    } catch (error) {
      console.error("Error opening document:", error);
      showErrorNotification("An error occurred while opening the document. Please try again.");
    }
  };


  const handleDrugTestDateChange = async (date, dateString) => {
    if (!date) {
      setIsChecked(false);
      setDrugTestDate(null);
      onFileUploadSuccess(false);
      localStorage.removeItem(`drugTestDate_${userId}`);
      localStorage.removeItem(`drugFile_${userId}`);
      const uid = `${userId}`

      try {
        const response = await deleteDrugTestDate(uid);
        if (response.ok) {
          setComments(null);
          showNotification("DrugTest record deleted successfully!");
        } else {
          showErrorNotification("DrugTest record deletion failed: " + response.data);
        }
      } catch (error) {
        console.error("Error removing drug test record:", error);
      }
    } else {
      setDrugTestDate(dateString);
      setIsChecked(true);
      onFileUploadSuccess(true);

      // Close the DatePicker
      document.activeElement.blur();

      const storedFile = localStorage.getItem(`drugFile_${userId}`);

      // ✅ Ensure storedFile is a valid JSON object before parsing
      let updatedFileData;
      try {
        updatedFileData = storedFile ? JSON.parse(storedFile) : {};
        if (typeof updatedFileData !== 'object' || Array.isArray(updatedFileData)) {
          updatedFileData = {};
        }
      } catch (error) {
        updatedFileData = {};
      }

      updatedFileData.drugTestDate = dateString;
      updatedFileData.isChecked = true;

      localStorage.setItem(`drugFile_${userId}`, JSON.stringify(updatedFileData));
      localStorage.setItem(`drugTestDate_${userId}`, dateString);

      const uid = `${userId}`;

      const requestData = { uid, attemptedDate: dateString, status: "Completed" };
      console.log("Sending request:", JSON.stringify(requestData));

      try {
        const response = await addDrugTestDate(requestData);
        if (response.ok) {
          console.log("Upload successful:", response.data);
          showNotification("DrugTest date added successfully!");
        } else {
          console.error("Upload failed:", response.data);
          showErrorNotification("Failed to update DrugTest date : " + response.data);
        }
      } catch (error) {
        console.error("Error updating drug test date:", error);
        showErrorNotification("Error occurred");
      }
    }
  };




  // Function to handle comment changes
  const handleCommentsChange = (e) => {
    setComments(e.target.value);
    if (e.target.value.trim() === '') {
      setCommentError(Labels.DrugTest_Comments_Error);
    } else {
      setCommentError('');
    }
  };
  // Function to handle Save Comment changes
  const handleSaveComment = async () => {
    if (!userId) {
      showWarningNotification("User ID is required to save the Comment.");
      return;
    }
    if (comments.trim() === "") {
      setCommentError(Labels.DrugTest_Comments_Error);
      setSubmitted(true);
      return;
    }

    setCommentError("");
    setSubmitted(false);
    setIsSaveClicked(true);

    // Save comments in localStorage to persist after reload
    localStorage.setItem(`comments_${userId}`, comments);
    const uid = `${userId}`;

    try {
      const response = await saveDrugTestComment(comments, uid)
      if (response.ok) {
        showNotification("Comments saved successfully!");
      } else {
        //const errorMsg = await response.text();
        showErrorNotification("Saving comment failed: " + response.data);
      }
    } catch (error) {
      showErrorNotification("An error occurred while saving the comments.");
    }
  };

  // Disable future dates in DatePicker
  const disableFutureDates = (current) => {
    return current && current > new Date();
  };
  const handleDelete = async () => {
    if (!userId) {
      showWarningNotification("User ID is required to delete the file.");
      return;
    }
    /* Modal.confirm({
       title: 'Are you sure you want to delete this file?',
       okText: 'Yes',
       cancelText: 'No',
       onOk: async () => {*/
    const uid = userId;
    try {
      const response = await deleteFileDrugTest(uid);

      if (response.ok && response.status != 404) {
        setUploadedFile(null);
        setFileName("");
        setFileData(null);
        onFileUploadSuccess(true);
        //setIsChecked(false);
        // localStorage.removeItem(`drugFile_${userId}`);
        showNotification("File deleted successfully!");
      } else {
        const errorMsg = await response.text();
        showErrorNotification("File deletion failed: " + errorMsg);
      }
    } catch (error) {
      showErrorNotification("An error occurred while deleting the file.");
    }
    /* },
     onCancel() {
       console.log('Deletion cancelled');
     },
   });*/
  };

  return (
    <div className="bordered-div container">
      {/* Drug Test Content Section */}
      <h2 className='custom-h2'>{Labels.DrugTest_Title}</h2>
      <p>{Labels.DrugTest_Description}</p>
      <p><strong>{Labels.DrugTest_Note}</strong><br />
        <ul>
          {Labels.DrugTest_Additional_Notes.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </p>
      {/* Date Picker for selecting drug test date with validation to not allow future dates */}
      <div style={{ marginBottom: '16px' }}>
        <h3>{Labels.DrugTest_Date_Label}
          <DatePicker
            value={drugTestDate ? moment(drugTestDate, "DD-MM-YYYY") : null}
            onChange={(date, dateString) => {
              handleDrugTestDateChange(date, dateString);
            }}
            placeholder={Labels.DrugTest_Date_Placeholder}
            style={{ width: '25%', marginLeft: '10px', borderColor: "rgb(31, 64, 90)", color: "gray", fontWeight: 'normal' }}
            disabledDate={disableFutureDates}
            disabled={isAdmin}
            format="DD-MM-YYYY"
          />
        </h3>
      </div>
      {/* Comments box for additional remarks */}
      <div style={{ marginBottom: '16px' }}>
        <Input.TextArea
          rows={4}
          value={comments}
          onChange={handleCommentsChange}
          placeholder={Labels.DrugTest_Comments_Placeholder}
          disabled={isAdmin}
          style={{
            width: '70%',
            borderColor: isSaveClicked && comments === '' ? 'red' : 'rgb(31, 64, 90)',
          }}
        />
        {/* Save Comment Button*/}
        <Button
          type="primary"
          className="custom-button-upload"
          onClick={handleSaveComment}
          disabled={isAdmin}
        >
          {Labels.DrugTest_Save_Comment_Button}
        </Button>
        {/* Display error message for Save Comment*/}
        {commentError && (
          <div style={{ color: 'red' }}>
            {commentError}
          </div>
        )}
      </div>
      {/* Upload Button */}
      <div>
        <input
          type="file"
          id="file-upload-drug"
          style={{ display: 'none' }}
          onChange={handleFileUpload}
          accept={Labels.DrugTest_Upload_Accepted_Types}
        />
        {isAdmin && <Button type="primary" className="custom-button-download" onClick={() => document.getElementById('file-upload-drug').click()} icon={<UploadOutlined />} >
          {Labels.DrugTest_Upload_Button}
        </Button>}
        {/* Display uploaded file name and link to open the document */}
        {fileName && isAdmin && (
          <p>
            <strong>{Labels.DrugTest_Upload_Label}</strong>
            <a href="#" onClick={downloadDocument}>
              {fileName}
            </a>
            {isAdmin && (
              <DeleteConfirmButton
              onConfirm={() => handleDelete()}
              buttonLabel={Labels.DrugTest_Delete_Button}
              />
            )}
          </p>
        )}
      </div>
      {/* Checkbox for completed drug test */}
      {drugTestDate && (
        <div style={{ marginTop: '16px' }}>
          <Checkbox
            checked={isChecked}
            disabled={isAdmin} // Only admins should not be able to interact with the checkbox
            className="custom-checkbox"
          >
            <strong style={{ marginBottom: '16px', color: "rgb(31, 64, 90)" }}>
              {Labels.DrugTest_Completed_Label}
            </strong>
          </Checkbox>
        </div>
      )}
    </div>
  );
}
export default DisplayDrugTest;